import styled from "styled-components";

export const ExpandingDescriptionStyles = styled.div`
  .titleAndArrow {
    display: flex;
    align-items: center;

    .title {
      font-style: normal;
      font-weight: 600;
      font-size: ${({ theme }) => theme.typography.body.b2.size};
      line-height: 17px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      margin-right: 17px;
    }

    .arrow {
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      transform: rotate(180deg);
    }

    .arrowUp {
      transform: rotate(0deg);
    }
  }

  .description {
    height: 0px;
    margin: ${({ theme }) => theme.spacing[12]} 0;
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    transition: all 0.2s ease-in-out;
    overflow: hidden;
  }
`;
